import React from 'react'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

function PostSetupStep({ createdEntityId }) {
  return (
    <MDBox mt={2}>
      <MDTypography variant="h6" fontWeight="medium" mb={1}>
        Onboarding complete
      </MDTypography>
      <MDTypography variant="body2" color="text" mb={2}>
        The customer has been created successfully.
      </MDTypography>

      {createdEntityId && (
        <MDTypography variant="body2" color="text" mb={2}>
          Created Entity ID: <strong>{createdEntityId}</strong> (also stored in localStorage)
        </MDTypography>
      )}

      <MDTypography variant="body2" color="text">
        You can now assign devices, configure provider sharing, and fine-tune notification rules
        from the entity and device management pages.
      </MDTypography>
    </MDBox>
  )
}

export default PostSetupStep

